import React from "react";
import TextInputForSelect from "../TextInputForSelect/TextInputForSelect";
import "./SelectInput.css";

class SelectInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuIsOpen: false,
    };
    this.options = React.createRef();
    this.input = React.createRef();
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleOnChangeValue = this.handleOnChangeValue.bind(this);
    this.handleOutsideClicks = this.handleOutsideClicks.bind(this);
  }

  handleOnClick(e) {
    e.stopPropagation();
    if (this.state.menuIsOpen === false) {
      this.setState(
        {
          menuIsOpen: true,
        },
        () => {
          document.addEventListener("click", this.handleOutsideClicks);
        }
      );
    } else {
      this.setState(
        {
          menuIsOpen: false,
        },
        () => {
          document.removeEventListener("click", this.handleOutsideClicks);
        }
      );
    }
  }

  handleOutsideClicks(e) {
    let target = e.target;
    if (target === this.input.current || target === this.options.current) {
      return;
    } else {
      this.setState(
        {
          menuIsOpen: false,
        },
        () => {
          document.removeEventListener("click", this.handleOutsideClicks);
        }
      );
    }
  }

  handleOnChangeValue(value) {
    this.setState(
      {
        menuIsOpen: false,
      },
      () => {
        document.removeEventListener("click", this.handleOutsideClicks);
        this.props.handleOnChangeValue(value);
      }
    );
  }

  render() {
    return this.props.data ? (
      <div className="select-input" style={{ zIndex: this.props.zIndexValue }}>
        <TextInputForSelect
          menuIsOpen={this.state.menuIsOpen}
          handleInputClick={this.handleOnClick}
          readOnly={true}
          name={this.props.name}
          value={this.props.inputValue}
          placeholder={this.props.placeholder}
          ref={this.input}
        />
        <ul
          ref={this.options}
          className={
            this.state.menuIsOpen
              ? "select-options select-options-show"
              : "select-options"
          }
        >
          {this.props.data.map((d) => (
            <li
              key={this.props.name + "_" + d.id}
              onClick={() => this.handleOnChangeValue(d.backendValue)}
            >
              {d.value}
            </li>
          ))}
        </ul>
      </div>
    ) : null;
  }
}

export default SelectInput;

// const SelectInput = (props) => {
//   return (
//     <Fragment>
//       {(props.data)
//       ? <select
//       className="select-input"
//       defaultValue={(props.default)
//       ? props.default
//       : props.placeholder}
//       onChange={props.onChangeSelect}>
//           {(props.placeholder) ? <option hidden>{props.placeholder}</option> : null}
//           {props.data.map(d => <option value={d.value} key={d.id}>{d.value}</option>)}
//        </select>
//       : null}
//     </Fragment>
//    );
// }

// export default SelectInput;
